module.exports = __webpack_public_path__ + "img/vs.911eed4e.png";